<template>
    <div class="quick-create-page">
        <template v-if="activeOrg && !canCreate">
            <div class="engine-page-message flex flex-align-center" style="background-color: #f56c6c;">
                <vip-icon :size="22" :type="activeOrg.accountType"></vip-icon>
                <div class="color-white margin-l-10">
                   {{$t('engine.QuickCreate_page_tips_1', {type: activeOrg.accountTypeDesc, count: userInfo.featureConfig.customGPTEngineCount || 0})}}<a href="mailto:languagex@besteasy.com" style="color:#fff;text-decoration: underline;">{{$t('engine.QuickCreate_page_tips_2')}}</a>
                </div>
            </div>
        </template>
        <div class="engine-page-message" v-else>
            <svg-icon name="ib-trumpet"></svg-icon> {{$t('engine.QuickCreate_page_tips_3')}}
        </div>
        <el-card class="engine-page-card">
            <el-form label-position="top" :disabled="formDisabled">
                <el-form-item :label="$t('engine.QuickCreate_page_form_item_label_1')" required>
                    <div class="flex flex-align-center">
                        <div class="flex flex-align-end" :disabled="formDisabled">
                            <el-popover placement="bottom-start" trigger="click">
                                <div class="engine-icon-list">
                                    <template v-for="(icon, index) in config.ENGINE_ICON_LIST">
                                        <div class="item" :key="index" @click="iconItemClick(icon)">
                                            <svg-icon :name="`ie-${icon}`"></svg-icon>
                                        </div>
                                    </template>
                                </div>
                                <div slot="reference" class="flex flex-align-center cursor-pointer">
                                    <div class="create-engine-icon">
                                        <svg-icon :name="`ie-${form.icon}`" style="font-size: 20px;"></svg-icon>
                                    </div>
                                    <i class="el-icon-arrow-down fonts-12 margin-l-5"></i>
                                </div>
                            </el-popover>
                        </div>
                        <el-input v-model="form.name" :placeholder="$t('engine.QuickCreate_page_placeholder_1')" :maxlength="10" style="width:300px; margin-left: 10px;" ></el-input>
                    </div>
                </el-form-item>
                <el-form-item required>
                    <template slot="label">{{$t('engine.QuickCreate_page_form_item_label_2')}}<span class="form-label-tips"></span></template>
                    <language-select ref="languageSelect" :list="languageList" :edit="formDisabled"></language-select>
                </el-form-item>
                <el-form-item required>
                    <template slot="label">{{$t('engine.QuickCreate_page_form_item_label_3')}}<span class="form-label-tips">{{$t('engine.QuickCreate_page_tips_4')}}</span></template>
                    <el-checkbox-group v-model="form.domains" :max="3" :disabled="formDisabled">
                        <div class="engine-label-grid">
                            <template v-for="(item, index) in engineLabelOptions">
                                <div class="item" :key="index">
                                    <el-checkbox :key="item.key" :value="item.key" :label="item.key">{{item.name}}</el-checkbox>
                                </div>
                            </template>
                        </div>
                    </el-checkbox-group>
                    
                </el-form-item>
                <el-form-item :label="$t('engine.QuickCreate_page_form_item_label_4')" style="margin-bottom: 0;">
                    <el-input v-model="form.descr" type="textarea" rows="2" maxlength="100" show-word-limit :placeholder="$t('engine.QuickCreate_page_placeholder_2')"></el-input>
                </el-form-item>
                
            </el-form>

        </el-card>
        <el-card class="engine-page-card">
            <el-form label-position="top" :disabled="formDisabled">
                <el-form-item :label="$t('engine.QuickCreate_page_form_item_label_5')">
                    <div class="flex">
                        <div>
                            <el-select v-model="form.styleType" :placeholder="$t('engine.QuickCreate_page_placeholder_3')" style="width: 125px;">
                                <template v-for="(item, index) in styleTypeOptions">
                                    <el-option :label="item.name" :value="item.key" :key="`styleType-${index}`"></el-option>
                                </template>
                            </el-select>
                        </div>
                        <div class="margin-l-10">
                            <el-select v-model="form.translateType" :placeholder="$t('engine.QuickCreate_page_placeholder_4')" style="width: 125px;">
                                <template v-for="(item, index) in translateTypeOptions">
                                    <el-option :label="item.name" :value="item.key" :key="`translateType-${index}`"></el-option>
                                </template>
                            </el-select>
                        </div>
                        <div class="margin-l-10 flex-1">
                            <el-input v-model="form.styleDesc" maxlength="100" show-word-limit :placeholder="$t('engine.QuickCreate_page_placeholder_5')"></el-input>
                        </div>
                    </div>
                    
                </el-form-item>
                <el-form-item required style="margin-bottom: 0;">
                    <el-image fit="contain" style="display:none;" ref="gptEngineExample"
                        src="https://nextcat.oss-accelerate.aliyuncs.com/fe_projects/example/gpt-engine-sample-1.png?OSSAccessKeyId=LTAI5tLMrodVLgCBBYxPFDRf&Expires=2678700498&Signature=gjCx75VZZgY%2FFT7A4p0YpMxJIqY%3D"
                        :preview-src-list="[
                            'https://nextcat.oss-accelerate.aliyuncs.com/fe_projects/example/gpt-engine-sample-1.png?OSSAccessKeyId=LTAI5tLMrodVLgCBBYxPFDRf&Expires=2678700498&Signature=gjCx75VZZgY%2FFT7A4p0YpMxJIqY%3D',
                            'https://nextcat.oss-accelerate.aliyuncs.com/fe_projects/example/gpt-engine-sample-2.png?OSSAccessKeyId=LTAI5tLMrodVLgCBBYxPFDRf&Expires=2678700523&Signature=NxdJI0eZMBikCfSuGHoiGJRFnhs%3D'
                        ]"></el-image>
                    <template slot="label">{{$t('engine.QuickCreate_page_form_item_label_6')}}<span class="margin-l-16 fonts-12">{{$t('engine.QuickCreate_page_tips_5')}}<a class="margin-l-10" href="javacript:;" @click="$refs.gptEngineExample.clickHandler()">{{$t('engine.QuickCreate_page_tips_6')}}</a></span></template>
                    <el-input v-model="form.doc" class="doc-textarea" type="textarea" rows="10" maxlength="4000" show-word-limit :placeholder="$t('engine.QuickCreate_page_placeholder_6')"></el-input>
                </el-form-item>
            </el-form>
        </el-card>
        <div class="action-content">
            <el-button type="primary" round :loading="formLoading" :disabled="formDisabled" @click="submitEvent">{{$t('engine.QuickCreate_page_btn_1')}}</el-button>
            <div class="fonts-12 margin-t-10">{{$t('engine.QuickCreate_page_tips_7')}}</div>
        </div>
        <el-dialog :title="$t('engine.QuickCreate_page_dialog_1_title')" :visible.sync="successDialogShow" @closed="$router.go(0)" destroy-on-close width="430px" top="20px">
            <div class="padding-20 text-center">
                <div class="color-success fonts-20"><i class="el-icon-success"></i></div>
                <div class="margin-t-15 fonts-15">{{$t('engine.QuickCreate_page_dialog_1_tips_1', {name: form.name})}}</div>
                <div class="margin-t-10 fonts-12">{{$t('engine.QuickCreate_page_dialog_1_tips_2')}}</div>
            </div>
            <div slot="footer" class="text-center">
                <el-button type="primary" size="mini" round @click="successDialogShow = false; $router.push('/engine/config');">{{$t('engine.QuickCreate_page_dialog_1_btn_1')}}</el-button>
                
            </div>
        </el-dialog>
    </div>
</template>
<script>
import config from '@/utils/config';
import LanguageSelect from '@/components/LanguageSelect';
import VipIcon from "@/components/icon/VipIcon";
import { mapState } from 'vuex';
import { myEngineApi } from '@/utils/api';
export default {
    components: { LanguageSelect, VipIcon },
    data () {
        return {
            config,
            canCreate: true,
            formDisabled: false,
            formLoading: false,
            form: {
                name: '',
                icon: '',
                descr: '',
                domains: [],
                styleLabel: [],
                styleType: '1',
                translateType: '1',
                styleDesc: '',
                doc: '',
            },
            languageList: [],
            taskData: {},
            taskTimer: {},
            successDialogShow: false,
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.user.userData,
            activeOrg: state => state.org.activeOrg,
            engineLabelOptions: state => state.common.engineLabels,
            styleTypeOptions: state => state.common.gptEngineStyleTypes,
            translateTypeOptions: state => state.common.gptEngineTranslateTypes,
        })
    },
    created () {
        this.languageList = [
            {key:'zh', name: this.$t('engine.QuickCreate_page_data_languageList_name_1'), shortName: this.$t('engine.QuickCreate_page_data_languageList_shortName_1')},
            {key:'en', name: this.$t('engine.QuickCreate_page_data_languageList_name_2'), shortName: this.$t('engine.QuickCreate_page_data_languageList_shortName_2')},
        ];
        this.queryCreatePermission();
        let size = config.ENGINE_ICON_LIST.length;
        this.form.icon = config.ENGINE_ICON_LIST[Math.floor(Math.random()*size)];
        this.$store.dispatch('common/initDictDataAction',{type: 'mt-domains-tags'});
        this.$store.dispatch('common/initDictDataAction',{type: 'mt-style-type'});
        this.$store.dispatch('common/initDictDataAction',{type: 'mt-translate-type'});
    },
    methods: {
        queryCreatePermission(){
            this.$ajax.get(myEngineApi.queryCreateGptPermission).then(res=>{
                if(res.status === 200){
                    this.canCreate = res.data.canCreate;
                    if(!res.data.canCreate){
                        this.formDisabled = true;
                    }
                }
            })
        },
        iconItemClick(icon) {
            this.form.icon = icon;
        },
        changeSelectStyleItem(item) {
            let index = this.form.styleLabel.indexOf(item);
            if(index > -1){
                this.form.styleLabel.splice(index, 1);
            }else {
                this.form.styleLabel.push(item);
            }
        },
        getSelectEngineLabelsName(){
            let rst = [];
            if (this.timerData.engine.domains){
                this.engineLabelOptions.map(item => {
                    if(this.timerData.engine.domains.indexOf(item.key*1) > -1){
                        rst.push(item.name);
                    }
                });
            }
            return rst.join("、");
        },
        submitEvent(){
            let self = this;
            this.lang = this.$refs.languageSelect.getValues();
            // console.log('xxxx:::', this.lang, this.form);
            
            if(!this.form.name){
                this.$message.error(this.$t('engine.QuickCreate_page_method_submitEvent_message_1'));
                return;
            }
            if(!(this.form.domains && this.form.domains.length > 0)){
                this.$message.error(this.$t('engine.QuickCreate_page_method_submitEvent_message_2'));
                return;
            }
            if(!this.form.doc){
                this.$message.error(this.$t('engine.QuickCreate_page_method_submitEvent_message_3'));
                return;
            }
            // return ;
            let url = myEngineApi.createGptEngineTask;
            let postData = {
                source: this.lang.sourceLang,
                target: this.lang.targetLang,
                engineName: this.form.name,
                domains: this.form.domains,
                descr: this.form.descr,
                icon: this.form.icon,
                styles: {
                    styleType: [this.form.styleType],
                    translateType: [this.form.translateType],
                },
                customStyle: this.form.styleDesc,
                corpus: this.form.doc,
            };
            this.formDisabled = true;
            this.formLoading = true;
            this.$ajax.post(url, postData).then(res => {
                if(res.status === 200) {
                    this.taskData = res.data;
                    this.queryTaskStatus();
                    this.taskTimer = setInterval(()=>{
                        self.queryTaskStatus();
                    }, 5000);
                }
            }).catch(e => {
                this.formDisabled = false;
                this.formLoading = false;
            })

        },
        queryTaskStatus(){
            let url = this.$ajax.format(myEngineApi.getGptTaskStatus, {id: this.taskData.modelId});
            this.$ajax.get(url).then(res => {
                if(res.status === 200){
                    if(res.data === 'used'){
                        clearInterval(this.taskTimer);
                        this.taskTimer = null;
                        this.formDisabled = false;
                        this.formLoading = false;
                        this.successDialogShow = true;
                    }
                }
            })
        }
    },
    mounted() {
        
    },
}
</script>
<style lang="scss" scoped>
.quick-create-page {
    padding: 12px 0 80px 0;
    width: 860px;
    margin: auto;
    .engine-page-card{
        margin-top: 12px;
        margin-bottom: 10px;
        border-radius: 10px;
        border: none;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04);
        ::v-deep .el-card__body{
            padding: 30px;
        }
        ::v-deep .el-form-item__label{
            line-height: 20px;
            font-size: 15px;
            color: #000000;
        }
        ::v-deep .el-input__count{
            line-height: 1;
        }
    }
    .form-label-tips{
        color: #E98C02;
        font-size: 12px;
        margin-left: 16px;
    }
    .engine-page-message{
        margin-top: 20px;
        font-size: 14px;
        line-height: 24px;
        padding: 10px 20px;
        background-color: #f7efe0;
        border-radius: 4px;
    }
    .create-engine-icon{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        box-sizing: border-box;
        border: 1px solid #cccccc;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    [disabled]{
        pointer-events: none;
        opacity: 0.4;
    }
    .engine-label-grid{
        display: grid;
        grid-gap: 10px;
        grid-template-columns: repeat(auto-fill,minmax(100px,1fr));
        line-height: 1;
    }
    .style-grid{
        display: grid;
        grid-gap: 15px;
        grid-template-columns: repeat(auto-fill,minmax(72px,1fr));
        .item {
            height: 36px;
            background-color: #F8F8F8;
            border: 1px solid transparent;
            border-radius: 4px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &.active {
                border-color: #000000;
            }
        }
    }
}
.doc-textarea{
    ::v-deep .el-textarea__inner{
        border-color: #7DD6B3;
    }
}
.engine-icon-list{
    display: flex;
    .item {
        font-size: 24px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        &:first-child{
            margin-left: 0;
        }
        &:hover{
            background-color: #f2f2f2;
        }
    }
}
.action-content{
    position: fixed;
    text-align: center;
    padding:10px;
    background-color:#f8f8f8;
    bottom: 0;
    width: 840px;
}
</style>
